"use client";

import createSvgIcon from "./utils/createSvgIcon.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "M11 12 8 8H2v14h20l-6-8zm1.53 2.77L6 16.95l-2-.67v-1.89l2 .67 3.95-1.32zM7 10l1.57 2.09-2.57.86-2-.67V10zM4 20v-1.61l2 .67 9.03-3.01L18 20zM17 6V1l-5-1-3 2v4l3 2zm-6-2.93 1.42-.95 2.58.52v2.01l-2.77 1.11L11 4.93zM18.5 7 16 9v3l2.5 2 4.5-2V8zm2.5 3.7-2.2.98-.8-.64V9.96l1-.8 2 .44z"
}), 'LandslideOutlined');